import { MenuItem } from "@blueprintjs/core";
import { type SidebarEntry } from "@package/ui-config";

export type SidebarMenuItemProps = SidebarEntry & {
  active?: boolean;
  onClick?: () => void;
};

export function SidebarMenuItem({
  icon,
  text,
  active = false,
  onClick,
}: SidebarMenuItemProps) {
  return <MenuItem icon={icon} text={text} active={active} onClick={onClick} />;
}
